var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img-fluid img-visibility statement-logo",attrs:{"src":require('@/assets/img/default_logo.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }